import * as Sentry from "@sentry/react";
import {
    generateId,
    generateWordSlug,
    isApiError,
    svTranslator,
} from "@towni/common";

import { browserLogger } from "./settings";
import { towniSessionId } from "./settings/towni-session-id";
import { currentTimezoneName } from "./shared/current-timezone-name";

const buildId = import.meta.env.VITE_BUILD_ID;
if (typeof buildId !== "string") throw new Error("Missing env var, BUILD_ID");
const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP;
if (typeof buildTimestamp !== "string")
    throw new Error("Missing env var, BUILD_TIMESTAMP");

Sentry.init({
    dsn: "https://edaf537be17b48e39e86d719a762ff73@o507275.ingest.sentry.io/5645406",
    release: buildId,
    environment: window.location.hostname,
    normalizeDepth: 10,
    // DOESN'T WORK WITHOUT SENTRY ESBUILD PLUGIN (https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration)
    // integrations: [Sentry.thirdPartyErrorFilterIntegration],
    beforeSend: (event, hint) => {
        const exception = hint.originalException;
        if (exception instanceof Error) {
            if (isApiError(exception)) {
                const reason = svTranslator(exception.reason);
                const explanation = svTranslator(exception.explanation);
                event.message =
                    reason || explanation
                        ? `${explanation ? `${explanation} ` : ""}${
                              reason ? `[Reason: ${reason}]` : ""
                          }`
                        : event.message;
            }
        }
        return event;
    },
    /**
     * We recommend adjusting this value in production, or using tracesSampler for finer control
     * This should be a float/double between 0.0 and 1.0 (inclusive) and represents the percentage chance that any given transaction will be sent to Sentry. (0.0 is a 0% chance, effectively disabling tracing, and 1.0 is a 100% chance, meaning all transactions will be sent.) This rate applies equally to all transactions; in other words, each transaction should have the same random chance of ending up with sampled = true, equal to the tracesSampleRate.
     * @param {ReturnType<typeof express>} app
     */
    tracesSampler: samplingContext => {
        // Examine provided context data (including parent decision, if any) along
        // with anything in the global namespace to compute the sample rate or
        // sampling decision for this transaction

        if (samplingContext.request?.method === "GET") {
            return 0.001;
        }

        return 1;
    },
    ignoreErrors: ["TypeError: Load failed", "Load failed"],
});
Sentry.getCurrentScope().setTags({
    "client-build-id": buildId,
    "client-build-timestamp": buildTimestamp,
    "transaction-id": `${generateWordSlug()}_${generateId({ length: 6 })}`,
    "client-timezone": currentTimezoneName,
    session_id: towniSessionId,
});

browserLogger.log("Sentry initialized");
browserLogger.log("Build Id:", buildId);
browserLogger.log("Build Timestamp:", buildTimestamp);
browserLogger.log("Towni Session Id:", towniSessionId);
browserLogger.log("Client timezone:", currentTimezoneName);

export {};
